/**
 * Postgres CREATE TABLE text, rebuilt from the system catalog (Postgres has no
 * SHOW CREATE TABLE). Injected into the DB Manager guest via toString — keep it
 * self-contained ES5 (see treeRefresh.js). The queries that feed it live in
 * entry.js `showCreate`; this only formats.
 *
 * It used to be rebuilt from information_schema: arrays and enums printed as
 * `ARRAY` / `USER-DEFINED`, and foreign keys, checks, indexes, triggers and
 * comments were missing. Now:
 *   columns     pg_attribute + format_type(atttypid, atttypmod) + pg_get_expr(default)
 *               + attidentity (IDENTITY) + attgenerated (GENERATED … STORED)
 *   constraints pg_get_constraintdef (PK, UNIQUE, CHECK, FK, EXCLUDE)
 *   indexes     pg_get_indexdef for indexes that do not back a constraint
 *   triggers    pg_get_triggerdef (user triggers only)
 *   comments    obj_description / col_description
 *
 * spec: { qualified, columns: [{ name, type, notNull, defaultExpr, identity, generated }],
 *         constraints: [{ name, def }], indexes: [def], triggers: [def],
 *         tableComment, columnComments: [{ name, comment }] }
 */
export function buildPgTableDdl(spec) {
  function ident(name) {
    return '"' + String(name).replace(/"/g, '""') + '"';
  }
  function literal(text) {
    return "'" + String(text).replace(/'/g, "''") + "'";
  }
  var lines = [];
  var cols = spec.columns || [];
  for (var i = 0; i < cols.length; i++) {
    var c = cols[i];
    var piece = '  ' + ident(c.name) + ' ' + c.type;
    if (c.identity === 'a') piece += ' GENERATED ALWAYS AS IDENTITY';
    else if (c.identity === 'd') piece += ' GENERATED BY DEFAULT AS IDENTITY';
    else if (c.generated === 's' && c.defaultExpr) piece += ' GENERATED ALWAYS AS (' + c.defaultExpr + ') STORED';
    else if (c.defaultExpr) piece += ' DEFAULT ' + c.defaultExpr;
    if (c.notNull) piece += ' NOT NULL';
    lines.push(piece);
  }
  var cons = spec.constraints || [];
  for (var j = 0; j < cons.length; j++) {
    lines.push('  CONSTRAINT ' + ident(cons[j].name) + ' ' + cons[j].def);
  }
  var out = '-- Rebuilt from the system catalog (Postgres has no SHOW CREATE TABLE).\n';
  out += 'CREATE TABLE ' + spec.qualified + ' (\n' + lines.join(',\n') + '\n);';
  var idx = spec.indexes || [];
  for (var k = 0; k < idx.length; k++) out += '\n\n' + idx[k] + ';';
  var trg = spec.triggers || [];
  for (var t = 0; t < trg.length; t++) out += '\n\n' + trg[t] + ';';
  if (spec.tableComment) out += '\n\nCOMMENT ON TABLE ' + spec.qualified + ' IS ' + literal(spec.tableComment) + ';';
  var cc = spec.columnComments || [];
  for (var m = 0; m < cc.length; m++) {
    out += '\n\nCOMMENT ON COLUMN ' + spec.qualified + '.' + ident(cc[m].name) + ' IS ' + literal(cc[m].comment) + ';';
  }
  return out;
}
